import { render } from "./App.vue?vue&type=template&id=31e32f4e&scoped=true"
const script = {}

import "./App.vue?vue&type=style&index=0&id=31e32f4e&scoped=true&lang=less"
import "./App.vue?vue&type=style&index=1&id=31e32f4e&lang=less"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31e32f4e"]])

export default __exports__